import React from 'react'
import "./Intro.css";
import Background from "../../images/back.png"
import Hero from "../../images/hero-1.png"
import {theamContex} from "../../Context";
import { useContext } from "react";
import {Link} from "react-scroll";

function Intro() {
  const theme = useContext(theamContex);
  const darkMode = theme.state.darkMode;
  return (
    <div id='Intro' className="intro" >
        <div className="intro-left">
            <div className="i-name">
                <span>Hi! I Am</span>
                <span>Dipak Patil</span>
                <span>Front-End Developer | Web Designer</span>
            </div>
            <Link spy={true} to='Contact' smooth={true} activeClass="activeClass">
              <button className="button i-button">Hire Me</button>
            </Link>
            <div className="i-icon">
              <a href="https://github.com/DipakPatil100" target="_blank" ><i class="fa-brands fa-github"></i></a>
              <a href="https://www.linkedin.com/in/dipakpatil100/" target="_blank"><i class="fa-brands fa-linkedin"></i></a>
              <a href="https://www.instagram.com/dipak_patil_08/" target="_blank"><i class="fa-brands fa-instagram"></i></a>
            </div>
        </div>
        <div className="tag-1"><i class="fa-solid fa-laptop-code"></i></div>
        <div className="intro-right">
            <img src={Background} alt="" />
            <img src={Hero} alt="" />
        </div>
        
        <div className="tag"
        style={{
          background: darkMode?'white':'',
          color: darkMode?'black':'',
        }}
        >
            <div className="tag-icon">
              <i class="fa-solid fa-crown"></i>
            </div>
            <div className="tag-name">
              Web <br></br>Developer
            </div>  
        </div>
         <div className="blur-1"></div>        
        <div className="blur"></div>   
        
    </div>
  )
}

export default Intro;